<div class="modal no-overflow  " [ngClass]="visible ? 'show' : ''">
    <div class="modal__layer" (click)="handleClose.emit()"></div>
    <div class="modal__box  show" id="modal01">
      <div class="modal__box__head" style="font-size: 18px;">
        Registro infracción Nº123456
        <a class="modal__close global-hand" (click)="handleClose.emit()"></a>
      </div>
      <div class="modal__box__body">

        <div style="align-items: center !important;
        justify-content: center !important;padding: 30px 30px;">

          <div class="row" >
            <div class="col-md-3 expansionCellsCarPerson">
              <div class="form containerForm">
                <label for="" class="label">
                  Nombre conductor
                </label>
                <p class="txt txt--small">
                  {{userData?.fullName}}
                </p>
              </div>
            </div>
            <div class="col-md-3 expansionCellsCarPerson">
              <div class="form containerForm">
                <label for="" class="label">
                  Cargo
                </label>
                <p class="txt txt--small">
                  {{ userData?.role }}
                </p>
              </div>
            </div>
            <div class="col-md-3 expansionCellsCarPerson">
              <div class="form containerForm">
                <label for="" class="label">
                  Gerencia
                </label>
                <p class="txt txt--small">
                  {{ userData?.management }}
                </p>
              </div>
            </div>
            <div class="col-md-3 expansionCellsCarPerson">
              <div class="form containerForm">
                <label for="" class="label">
                  Sistema turno
                </label>
                <p class="txt txt--small">
                 {{ userData?.shiftWork }}
                </p>
              </div>
            </div>
          </div>

          <div class="row" >
            <div class="col-md-3 expansionCellsCarPerson">
              <div class="form containerForm">
                <label for="" class="label">
                  Rut
                </label>
                <p class="txt txt--small">
                  {{userData?.rutDv}}
                </p>
              </div>
            </div>
            <div class="col-md-3 expansionCellsCarPerson">
              <div class="form containerForm">
                <label for="" class="label">
                  Empresa
                </label>
                <p class="txt txt--small">
                  {{ userData?.company }}
                </p>
              </div>
            </div>
            <div class="col-md-3 expansionCellsCarPerson">
              <div class="form containerForm">
                <label for="" class="label">
                  Unidad de negocio
                </label>
                <p class="txt txt--small">
                  {{ userData?.businessUnit }}
                </p>
              </div>
            </div>
            <div class="col-md-3 expansionCellsCarPerson">
              <div class="form containerForm">
                <label for="" class="label">
                  Correo electrónico
                </label>
                <p class="txt txt--small">
                 {{ userData?.email }}
                </p>
              </div>
            </div>
          </div>

        </div>


      </div>
      <div class="modal__box__footer" style="text-align: center; padding: 10px !important;"  (click)="handleClose.emit()">
        <a class="btn btn--link" style="font-size: 16px !important;">Cerrar</a>
      </div>
    </div>
  </div>
